import Typography from 'hb-builder/components/common/SettingsLibrary/ComposedInputs/Typography';
import AccordionTitle from 'hb-builder/components/common/SettingsLibrary/SettingsDecoration/AccordionTitle';
import type {
  ComponentSettingsTab,
  OnChangeSettingsArgs,
} from 'hb-builder/types/settings';
import type { HeroItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/heroItemAttributes';

type SublinesSettingSettingsProps = {
  headerIds: string[];
} & Pick<
  ComponentSettingsTab<HeroItemAttributes>,
  'permissions' | 'onChange' | 'item'
>;

const HeadlinesSetting = ({
  item,
  headerIds,
  onChange,
  permissions,
}: SublinesSettingSettingsProps) => {
  const { can } = permissions || {};
  const onHeadlineChanges = ({
    settingKey,
    value,
    values,
  }: OnChangeSettingsArgs) => {
    onChange({ ids: headerIds, settingKey, value, values });
  };

  return (
    <AccordionTitle title={__('Headlines')}>
      <Typography
        item={item}
        onChange={onHeadlineChanges}
        includeTextBackground={can?.updateTextBackground}
        defaultAttributes={{} as HeroItemAttributes}
      />
    </AccordionTitle>
  );
};

export default HeadlinesSetting;
